// Estilo inline compartido para los botones "Siguiente"/"Confirmar" de los
// flujos con pasos tipo acordeón (Customize.jsx, Carrito.jsx): atenuado y
// no clickeable mientras el paso no está habilitado.
export const getButtonStyle = (enabled) => ({
  marginTop: '1rem',
  opacity: enabled ? 1 : 0.5,
  cursor: enabled ? 'pointer' : 'not-allowed',
  pointerEvents: enabled ? 'auto' : 'none',
  transition: 'all 0.3s',
  padding: '0.5rem 1rem',
  borderRadius: '2px',
  border: '1px solid #202020',
  backgroundColor: '#202020',
  color: '#f4f4f4',
  fontWeight: '600',
  letterSpacing: '0.04em',
});
